module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-2.webp?2008c8c9";